/**
 * Validates an email address using a regex pattern
 * @param email The email address to validate
 * @returns true if the email is valid, false otherwise
 */
export function isValidEmail(email: string): boolean {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
}

/**
 * Adds an email to the distribution list if it's valid and not already present
 * @param value The email value to add
 * @param inputElement The input element to clear/update
 * @param currentDistributions The current list of email distributions
 * @returns The updated distribution list
 */
export function addEmailToDistributions(
    value: string,
    inputElement: HTMLInputElement,
    currentDistributions: string[]
): string[] {
    const trimmedEmail = value.trim();

    if (!trimmedEmail) {
        return currentDistributions;
    }

    if (!isValidEmail(trimmedEmail)) {
        inputElement.value = trimmedEmail;
        return currentDistributions;
    }

    if (currentDistributions.includes(trimmedEmail)) {
        inputElement.value = '';
        return currentDistributions;
    }

    inputElement.value = '';
    return [...currentDistributions, trimmedEmail];
}

/**
 * Removes an email from the distribution list
 * @param email The email to remove
 * @param currentDistributions The current list of email distributions
 * @returns The updated distribution list
 */
export function removeEmailFromDistributions(
    email: string,
    currentDistributions: string[]
): string[] {
    return currentDistributions.filter(e => e !== email);
}
